import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ListModule } from 'src/@fury/shared/list/list.module';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatTableModule } from '@angular/material/table';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';


import { GlobalIpAccessRoutingModule } from './global-ip-access-routing.module';
import { GlobalIpAccessComponent } from './global-ip-access.component';
import { GlobalIpAccessListComponent } from './global-ip-access-list/global-ip-access-list.component';
import { GlobalIpAddEditComponent } from './global-ip-add-edit/global-ip-add-edit.component';


@NgModule({
  declarations: [
    GlobalIpAccessComponent,
    GlobalIpAccessListComponent,
    GlobalIpAddEditComponent
  ],
  imports: [
    CommonModule,
    GlobalIpAccessRoutingModule,
    FurySharedModule,
    ListModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    MatTableModule,
    FlexLayoutModule,
    MatIconModule,
    MatSlideToggleModule,
    NgxPaginationModule,
    MatPaginatorModule,
    MatSelectModule,
    MatOptionModule,
  ]
})
export class GlobalIpAccessModule { }
